import { useState, useEffect } from 'react';
import MissingIcon from "../../images/missing.jpg";
import { getStorage, ref as storageRef, getDownloadURL } from "firebase/storage";

function CTACampaignsCard({data, cta, setModalState}) {

  const storage = getStorage();
  const defaultRow = <tr key="1" role="row">
    <td className="p-2">

    </td>
    <td className="p-2">
      <div className="text-center"></div>
    </td>
    <td className="p-2">
      <div className="text-center text-gray-400">
        <div className="sm:flex w-full mt-4 p-2">
          <div className="m-auto text-center">
            <svg className="animate-spin h-5 w-full" viewBox="0 0 100 100">
              <circle cx="50" cy="50" r="45" stroke="#F7699F" strokeWidth="6" fill="transparent" strokeLinecap="round"
                      strokeDasharray="283" strokeDashoffset="75"/>
            </svg>
          </div>
        </div>
      </div>
    </td>
    <td className="p-2">
      <div className="text-center"></div>
    </td>
    <td className="p-2">
      <div className="text-center"></div>
    </td>
  </tr>

  const [rows, setRows] = useState([]);

  useEffect(() => {
    OnLoad();
  }, [data]);

  async function OnLoad() {
    if(data!=null) {
      var icons = {}
      for(var n of data) {
        try {
          if(!icons.hasOwnProperty(n.app))
            icons[n.app] = await getDownloadURL(storageRef(storage, n.app + '.jpg'))
        }
        catch (e){
          n['icon'] = MissingIcon
        }
      }
      setRows(data.map((item) =>
          <tr className="cursor-pointer hover:font-black" key={item.id} role="row" onClick={()=>setModalState({title: 'tite',
            item: item, icon: icons[item.app]})}>
            <td className="p-2">
              <div className="flex items-center">
                <img className="rounded-full flex-shrink-0 mr-2 sm:mr-3" src={icons[item.app]} width="24" height="24" alt=''/>
                <div className="text-center">{item.brand}</div>
              </div>
            </td>
            <td className="p-2">
              <div className="text-center">{item.market}</div>
            </td>
            <td className="p-2">
              <div className="flex items-center">
                <div className="text-gray-800 line-clamp-1">{item.text}</div>
              </div>
            </td>
            <td className="p-2">
              <div className="text-center">{item.time}</div>
            </td>
            <td className="p-2">
              <div className="text-center">{item.date}</div>
            </td>
          </tr>
      ));
    }
  }

  return (
    <div className="w-full col-span-full xl:col-span-12 bg-white shadow-1 rounded-sm border border-gray-200">
      <header className="px-5 py-4 border-b border-gray-100 flex">
        <h2 className="font-semibold text-gray-800">Live "{cta}" Campaigns </h2>
      </header>
      <div className="p-3">

        {/* Table */}
        <div className="overflow-x-auto max-h-60 overflow-y-scroll">
          <table className="table-auto w-full">
            {/* Table header */}
            <thead className="text-xs uppercase text-gray-400 bg-gray-50 rounded-sm">
              <tr>
                <th className="p-2">
                  <div className="font-semibold text-left">Brand</div>
                </th>
                <th className="p-2">
                  <div className="font-semibold text-center">Market</div>
                </th>
                <th className="p-3 w-2/4">
                  <div className="font-semibold text-center">Message</div>
                </th>
                <th className="p-2">
                  <div className="font-semibold text-center">Time Sent</div>
                </th>
                <th className="p-2">
                  <div className="font-semibold text-center">Date Sent</div>
                </th>
              </tr>
            </thead>
            {/* Table body */}
            <tbody className="text-sm font-medium divide-y divide-gray-100">
              {
                rows.length===0?defaultRow:rows
              }
            </tbody>
          </table>

        </div>
      </div>
    </div>
  );
}

export default CTACampaignsCard;
